module.exports = __webpack_public_path__ + "img/banner6.49222925.png";